export default __webpack_public_path__ + "static/media/IMG_3808 copie.2fc47b84.jpg";